import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=3936fecc&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=3936fecc&prod&lang=scss"
import style1 from "./customer.vue?vue&type=style&index=1&id=3936fecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936fecc",
  null
  
)

export default component.exports